import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { isAxiosError } from 'axios';
import { ErrorResponse } from '~/infra/error-response/ErrorResponse';
export const classifyBootOutcome = (error)=>{
    if (isAxiosError(error) && error.response == null) return 'networkError';
    if (new ErrorResponse(error).status === 401) return 'sessionExpired';
    return 'serverError';
};
export class UserInfoFetchError extends Error {
    constructor(reason){
        super('Failed to get user info'), _define_property(this, "reason", void 0), this.reason = reason;
    }
}
export const userInfoFailureReason = (error)=>{
    if (classifyBootOutcome(error) === 'networkError') return 'network';
    const { status } = new ErrorResponse(error);
    return status == null ? 'non_http' : "http_".concat(status);
};
